// const I18NextHttpBackend = require("i18next-http-backend");

module.exports = {
  i18n: {
    defaultLocale: "zh",
    // locales: ["en", "zh", "ar", "fr", "ru", "es"],
    locales: ["en", "zh", "ru", "pt"],
    defaultNS: ["index"],
    // fallbackLng: "zh",
    // backend: {
    //   loadPath: `/public/locales/{{lng}}`,
    // },
  },
  //   localePath: `public/locales`,
  debug: false,
  isLocal: process.env.ENV_NAME === "local",
};
